module.exports = __webpack_public_path__ + "img/key-account-update.e87c5d95.svg";